export default __webpack_public_path__ + "static/media/white-close-sp.89a062cd.svg";